import * as React from 'react';
import { useAppointmentManyV2 } from 'ui-model';
import { useCurrentUser } from '@lib/hooks';

function useUpcomingAppointments(currentDate: Date) {
  const currentUser = useCurrentUser();

  const { data: upcomingAppointmentsData, isLoading, refetch } = useAppointmentManyV2(
    {
      patient: currentUser?.id,
      date: `>=${currentDate.toISOString()}`,
      status: 'confirmed,unconfirmed',
      _populate:
        'facility.name,facility.address,facility.phone,facility.settings,type.name,type.modality,type.settings,provider.name',
      limit: 10,
    },
    { keepPreviousData: true },
  );

  const upcomingAppointmentsList = React.useMemo(() => upcomingAppointmentsData?.pages?.[0] || [], [
    upcomingAppointmentsData,
  ]);

  return {
    isLoading,
    refetch,
    upcomingAppointmentsList,
  };
}

export default useUpcomingAppointments;
